/** @component tabs */
import React from 'react';
import PropTypes from 'prop-types';

var TabContent = function TabContent(props) {
  var children = props.children,
      activeIndex = props.activeIndex;
  var setPanels = React.Children.map(children, function (child, idx) {
    return /*#__PURE__*/React.cloneElement(child, {
      active: activeIndex === idx ? true : false
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "md-tab__content"
  }, setPanels);
};

TabContent.propTypes = {
  /** @prop Determines the initial active index | null */
  activeIndex: PropTypes.number,

  /** @prop Children nodes to render inside TabContent | null */
  children: PropTypes.node
};
TabContent.defaultProps = {
  activeIndex: null,
  children: null
};
TabContent.displayName = 'TabContent';
export default TabContent;